/* eslint-disable node/no-extraneous-import, import/no-unresolved */
import aspectRatio from "./aspectRatio.js";
import avoid from "./avoid/avoid.js";
import restrictEdges from "./restrict/edges.js";
import restrict from "./restrict/pointer.js";
import restrictRect from "./restrict/rect.js";
import restrictSize from "./restrict/size.js";
import rubberband from "./rubberband/rubberband.js";
import snapEdges from "./snap/edges.js";
import snap from "./snap/pointer.js";
import snapSize from "./snap/size.js";
import spring from "./spring/spring.js";
import transform from "./transform/transform.js";
export default {
  aspectRatio,
  restrictEdges,
  restrict,
  restrictRect,
  restrictSize,
  snapEdges,
  snap,
  snapSize,
  spring,
  avoid,
  transform,
  rubberband
};
//# sourceMappingURL=all.js.map